import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'

import { withRtl } from '../../../components/hoc';
import style from './ScheduleButton.scss'; // eslint-disable-line css-modules/no-unused-class

const ScheduleButton = ({ label, ariaLabel, icon=null, onClick, secondary=false, disabled=false, large=false }) => (
  <button
    className={classNames('button--no-style', style.button, {
      [style.buttonSecondary]: secondary,
      [style.buttonDisabled]: disabled, // eslint-disable-line css-modules/no-undef-class
      [style.buttonLarge]: large,
    })}
    onClick={disabled ? null : onClick}
    aria-label={ariaLabel || label}
    disabled={disabled}
  >
    <span className={style.buttonLabel}>{label}</span>
    {icon && (
      <span className={style.buttonIcon}>
        {!disabled && (<i className={`icon-${icon}`} />)}
      </span>
    )}
  </button>
);

ScheduleButton.propTypes = {
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  icon: PropTypes.string,
  secondary: PropTypes.bool,
  disabled: PropTypes.bool,
  large: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default withRtl(style)(withStyles(style)(ScheduleButton));
